"use strict";
exports.__esModule = true;
var crs_1 = require("./crs");
var lnglat_projection_1 = require("../projection/lnglat-projection");
var transformation_1 = require("../transformation");
var util_1 = require("@antv/util");
var transform = new transformation_1.Transformation(1, 0, -1, 0);
// @ts-ignore
exports.simple = util_1.mix({}, crs_1.CRS, {
    projection: lnglat_projection_1.lngLatProjection,
    transformation: transform,
    scale: function (zoom) {
        return Math.pow(2, zoom);
    },
    zoom: function (scale) {
        return Math.log(scale) / Math.LN2;
    },
    distance: function (latlng1, latlng2) {
        var dx = latlng2.lng - latlng1.lng;
        var dy = latlng2.lat - latlng1.lat;
        return Math.sqrt(dx * dx + dy * dy);
    },
    infinite: true
});
//# sourceMappingURL=crs-simple.js.map